<template>
    <div class="steps">
        <h2 class="section-title">Как это работает</h2>
        <p class="steps__subtitle">Схема перевозки груза</p>
        <div class="steps__list">
            <div class="steps__list-item">
                <div class="steps__list-item-number">Шаг 1</div>
                <p class="steps__list-item-text">
                    Вы привозите груз в отделение компании. Мы также можем забрать груз по
                    указанному адресу в удобное для вас время — просто закажите услугу «Забор груза»
                </p>
            </div>
            <div class="steps__list-item">
                <div class="steps__list-item-number">Шаг 2</div>
                <p class="steps__list-item-text">
                    Готовим груз к перевозке: упаковываем, маркируем уникальным штрихкодом
                </p>
            </div>
            <div class="steps__list-item">
                <div class="steps__list-item-number">Шаг 3</div>
                <p class="steps__list-item-text">
                    Доставляем груз на склад ПЭК в пункте назначения
                </p>
            </div>
            <div class="steps__list-item">
                <div class="steps__list-item-number">Шаг 4</div>
                <p class="steps__list-item-text">
                    Оповещаем вас о прибытии груза. Уточнить его местоположение также можно самостоятельно
                    — с помощью мобильного приложения или официального сайта ПЭК
                </p>
            </div>
            <div class="steps__list-item">
                <div class="steps__list-item-number">Шаг 5</div>
                <p class="steps__list-item-text">
                    Выдаём груз в отделении компании или доставляем получателю по указанному
                    при оформлении адресу, если выбрана услуга «Доставка груза»
                </p>
            </div>
        </div>
    </div>
</template>
<style scoped>
.steps {
    padding: 32px;
    margin-top: 80px;
    background-color: #F5F5F5;
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-radius: 20px;
}
.steps__subtitle {
    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    margin: 0;
}
.steps__list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-radius: 16px;
}
.steps__list-item {
    border-radius: 16px;
    padding: 20px;
    background-color: #FFFFFF;
    display: flex;
    gap: 16px;
    align-items: center;
}
.steps__list-item-number {
    min-width: 60px;
    padding: 6px 8px;
    background-color: #48538B1A;
    color: #48538B;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    border-radius: 8px;
    margin: 0;
}
.steps__list-item-text {
    font-weight: 500;
    font-style: Medium;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.section-title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 46px;
    letter-spacing: 0%;
    margin: 0;
}
@media screen and (max-width: 1279px) {
    .section-title {
        font-size: 24px;
        line-height: 32px;
    }
    .steps__list-item {
        flex-direction: column;
        align-items: flex-start
    }
}
@media screen and (max-width: 768px) {
    .section-title {
        font-size: 22px;
        line-height: 28px;
    }
    .steps {
        padding: 16px;
    }
    .steps__subtitle {
        font-size: 16px;
        line-height: 24px;
    }
    .steps__list-item {
        padding: 16px;
    }
    .steps__list-item-text {
        font-size: 16px;
        line-height: 26px;
    }
}
@media screen and (max-width: 768px) {
    .steps {
        margin-top: 40px;
    }
}
</style>